import * as React from 'react';
import { Icon } from './icons.jsx';
import { Button } from './ui.jsx';

const SIGNALS = ['Easy to understand', 'Confusing', 'Missing something', 'Would use this'];

export const FeedbackPanel = ({ route }) => {
  const [open, setOpen] = React.useState(false);
  const [audience, setAudience] = React.useState('Family');
  const [signal, setSignal] = React.useState(SIGNALS[0]);
  const [note, setNote] = React.useState('');
  const [saved, setSaved] = React.useState(false);
  const [error, setError] = React.useState('');

  const save = (event) => {
    event.preventDefault();
    setError('');
    try {
      const key = 'fmc_prototype_feedback';
      const existing = JSON.parse(window.localStorage.getItem(key) || '[]');
      const entries = Array.isArray(existing) ? existing : [];
      entries.push({
        route,
        audience,
        signal,
        note: note.trim(),
        createdAt: new Date().toISOString(),
      });
      window.localStorage.setItem(key, JSON.stringify(entries));
      setSaved(true);
      setNote('');
    } catch {
      setError('This browser could not save your feedback. Please copy your note before closing.');
    }
  };

  return (
    <aside
      className={`feedback-widget ${open ? 'is-open' : ''} ${route === 'dashboard' ? 'is-dashboard' : ''} ${route === 'results' ? 'above-comparison' : ''}`}
      aria-label="Prototype feedback"
    >
      {open && (
        <div className="feedback-panel">
          <div className="feedback-heading">
            <div>
              <span>Shareholder testing</span>
              <h2>What should we improve?</h2>
            </div>
            <button type="button" onClick={() => setOpen(false)} aria-label="Close feedback">
              <Icon name="x" size={17}/>
            </button>
          </div>

          {saved ? (
            <div className="feedback-receipt" role="status">
              <Icon name="check-circle" size={24}/>
              <strong>Feedback saved on this device</strong>
              <p>This prototype does not send feedback to the team yet.</p>
              <Button variant="secondary" size="sm" onClick={() => setSaved(false)}>
                Add another note
              </Button>
            </div>
          ) : (
            <form onSubmit={save}>
              <label>
                I am reviewing as
                <select value={audience} onChange={(event) => setAudience(event.target.value)}>
                  <option>Family</option>
                  <option>Provider</option>
                  <option>Partner</option>
                </select>
              </label>

              <fieldset>
                <legend>This page feels</legend>
                <div className="feedback-signals">
                  {SIGNALS.map((item) => (
                    <button
                      type="button"
                      key={item}
                      className={signal === item ? 'is-selected' : ''}
                      aria-pressed={signal === item}
                      onClick={() => setSignal(item)}
                    >
                      {item}
                    </button>
                  ))}
                </div>
              </fieldset>

              <label>
                What should we know?
                <textarea
                  value={note}
                  onChange={(event) => setNote(event.target.value)}
                  placeholder="Tell us what worked, what was confusing, or what you expected."
                  rows={4}
                />
              </label>
              {error && <p className="feedback-error" role="alert">{error}</p>}
              <Button type="submit" full disabled={!note.trim()}>
                Save feedback on this device
              </Button>
            </form>
          )}
        </div>
      )}
      <button
        type="button"
        className="feedback-launcher"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <Icon name="message" size={16}/>
        Feedback
      </button>
    </aside>
  );
};
